<template>
  <div class="reader-selector--option" @click="onClick">
    <StateButton :reader-id="readerId" :populated="true" />
    <div class="label">{{ title }}</div>
  </div>
</template>

<script>
  import StateButton from '../ReaderStateButtons/StateButton.vue';

  export default {
    components: { StateButton },
    props: {
      title: {
        type: String,
        required: true,
      },
      readerId: {
        type: String,
        required: true,
      },
    },
    methods: {
      onClick() {
        this.$emit('selected', this.readerId);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../variables';
  #app[data-locale="ar"] .reader-selector--option {
    direction: rtl;
    .label {
      padding-left: 0;
      padding-right: 8px;
      margin: auto 0;
    }
  }

  .reader-selector--option {
    padding: 0.5rem 0.75rem;
    display: flex;
    &:hover {
      background: $gray-100;
    }
    cursor: pointer;
    .label {
      padding-left: 5px;
      margin: auto 0;
    }
  }
</style>
